const config = {
    BASE_URL: 'https://api.betsmarter.app',
    // BASE_URL: 'http://localhost:4200',
}

export default config;